
import React from "react";
import { TableCell, TableRow } from "@/components/ui/table";
import { AttendeesList } from "./AttendeesList";
import { useIsMobile } from "@/hooks/use-mobile";

interface ClassDetailsRowProps {
  attendees: any[];
  classId: string;
  classDate: string;
  updatingAttendanceId: string | null;
  removingClientId: string | null;
  onMarkAttendance?: (bookingId: string, attended: boolean, userName: string) => Promise<boolean>;
  onRemoveClient?: (classId: string, userId: string, date: string, userName: string) => Promise<boolean>;
}

export const ClassDetailsRow: React.FC<ClassDetailsRowProps> = ({
  attendees,
  classId,
  classDate,
  updatingAttendanceId,
  removingClientId,
  onMarkAttendance,
  onRemoveClient
}) => {
  const isMobile = useIsMobile();
  
  return (
    <TableRow>
      <TableCell colSpan={6} className="bg-secondary/5 p-0">
        <div className={`${isMobile ? "p-1" : "p-4"}`}>
          <h4 className={`${isMobile ? "text-[10px]" : "text-sm"} font-medium mb-1`}>Participants du cours</h4>
          <AttendeesList 
            attendees={attendees}
            classId={classId}
            classDate={classDate}
            onMarkAttendance={onMarkAttendance}
            onRemoveClient={onRemoveClient}
            updatingAttendanceId={updatingAttendanceId}
            removingClientId={removingClientId}
          />
        </div>
      </TableCell>
    </TableRow>
  );
};
